// extracted by mini-css-extract-plugin
export default {"card":"WNZ3jStLV1Aovlz2Rm4c","community-title":"wHuPnon4dYVF28MH2ORG","community-type":"fZ8hlHMQMc9BTWO2UqAq","optional":"kiB6soMNHNMEmC_IrVpG","docs-link":"nc_mx7iXhJ6MVJS6jwvX"};